import $ from 'jquery'
import debounce from 'lodash.debounce'

/*
 Docs:
 https://googlemaps.github.io/js-markerclustererplus/index.html

 Blog articles:
 https://blog.codecentric.de/2018/04/google-maps-api-geojson/
 https://mono.software/2017/12/29/google-maps-marker-clustering/
 https://stackoverflow.com/questions/40904882/clustering-markers-from-geojson-using-google-maps
 */

let infoWindow

// store values for reverse geocoding (getting address via browser geolocation and google maps api)
// we suppose the user will be on the same location while having the site open
let reverseGeocodingAddress, reverseGeocodingLat = 0, reverseGeocodingLng = 0

// store recent location values if we need to jump from location finder large to the location finder page
let recentCountry, recentLat, recentLng

// country name where the search applies to
let currentCountryName = 'Deutschland'
let currentLocale = '' // read on init from html
const worldWide = 'en_GG' // read for grenke-group

let markerClusterCurrentCountry
let markerClusterCurrentLocation
let markerClusterOthers
let apiData = null
let currentLatLng = null

let clusterIconHeight = 56
let clusterIconWidth = 32
let markerIconHeight = 46
let markerIconWidth = 33
let currentLocationHeight = 48
let currentLocationWidth = 32
let textColor = 'white'
let textLineHeight = 52
let textSize = 14
if (window._newDesign) {
  clusterIconHeight = 48
  clusterIconWidth = 48
  markerIconHeight = 48
  markerIconWidth = 48
  currentLocationHeight = 48
  currentLocationWidth = 48
  textColor = 'black'
  textLineHeight = 42
}

const mapStyle = [
  {
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#f5f5f5'
      }
    ]
  },
  {
    'elementType': 'labels.icon',
    'stylers': [
      {
        'visibility': 'off'
      }
    ]
  },
  {
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#616161'
      }
    ]
  },
  {
    'elementType': 'labels.text.stroke',
    'stylers': [
      {
        'color': '#f5f5f5'
      }
    ]
  },
  {
    'featureType': 'administrative.country',
    'elementType': 'geometry.stroke',
    'stylers': [
      {
        'color': '#838383'
      },
      {
        'visibility': 'on'
      }
    ]
  },
  {
    'featureType': 'administrative.land_parcel',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#bdbdbd'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#eeeeee'
      }
    ]
  },
  {
    'featureType': 'poi',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#757575'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e5e5e5'
      }
    ]
  },
  {
    'featureType': 'poi.park',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  },
  {
    'featureType': 'road',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#ffffff'
      }
    ]
  },
  {
    'featureType': 'road.arterial',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#757575'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#dadada'
      }
    ]
  },
  {
    'featureType': 'road.highway',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#616161'
      }
    ]
  },
  {
    'featureType': 'road.local',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  },
  {
    'featureType': 'transit.line',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#e5e5e5'
      }
    ]
  },
  {
    'featureType': 'transit.station',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#eeeeee'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'geometry',
    'stylers': [
      {
        'color': '#c9c9c9'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'geometry.fill',
    'stylers': [
      {
        'color': '#d5e7ed'
      }
    ]
  },
  {
    'featureType': 'water',
    'elementType': 'labels.text.fill',
    'stylers': [
      {
        'color': '#9e9e9e'
      }
    ]
  }
]

let clusterStylesCurrent = [
  {
    textColor: 'white',
    url: window._mapClusterIcon,
    height: clusterIconHeight,
    width: clusterIconWidth,
    textLineHeight: textLineHeight,
    textSize: textSize,
  },
  {
    textColor: 'white',
    url: window._mapClusterIcon,
    height: clusterIconHeight,
    width: clusterIconWidth,
    textLineHeight: textLineHeight,
    textSize: textSize,
  },
  {
    textColor: 'white',
    url: window._mapClusterIcon,
    height: clusterIconHeight,
    width: clusterIconWidth,
    textLineHeight: textLineHeight,
    textSize: textSize,
  }
]

let clusterStylesOthers = [
  {
    textColor: textColor,
    url: window._mapClusterIconInternational,
    height: clusterIconHeight,
    width: clusterIconWidth,
    textLineHeight: textLineHeight,
    textSize: textSize,
  },
  {
    textColor: textColor,
    url: window._mapClusterIconInternational,
    height: clusterIconHeight,
    width: clusterIconWidth,
    textLineHeight: textLineHeight,
    textSize: textSize,
  },
  {
    textColor: textColor,
    url: window._mapClusterIconInternational,
    height: clusterIconHeight,
    width: clusterIconWidth,
    textLineHeight: textLineHeight,
    textSize: textSize,
  }
]

let mcOptionsCurrent = {
  averageCenter: true,
  gridSize: 45,
  styles: clusterStylesCurrent,
  minimumClusterSize: 3,
  maxZoom: 15 // the zoom level when markers appear as clusters, all higher levels display them as single markers
}

let mcOptionsOthers = {
  averageCenter: true,
  gridSize: 45,
  styles: clusterStylesOthers,
  minimumClusterSize: 3,
  maxZoom: 15 // the zoom level when markers appear as clusters, all higher levels display them as single markers
}

let map

function initMap () {
  map = new google.maps.Map(document.getElementById('location-map'), {
    scrollwheel: false,
    maxZoom: 16, // should be 1 higher than mcOptionsCurrent.maxZoom for proper marker display in BAD
    zoom: 8,
    zoomControl: true,
    zoomControlOptions: {
      position: google.maps.ControlPosition.RIGHT_TOP
    },
    mapTypeControl: false,
    scaleControl: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: mapStyle
  })

  // the info window when clicking a marker
  // use InfoBox instead of google.maps.InfoWindow for better customization, see: https://github.com/googlemaps/v3-utility-library/tree/master/infobox
  infoWindow = new InfoBox({
    pixelOffset: new google.maps.Size(30, -70),
    closeBoxURL: window._mapBoxCloseIcon,
    enableEventPropagation: true
  })

  // use this event to adjust the infobox the first time, because the 'content_changed' event sometimes fires before the box is present in dom
  google.maps.event.addListener(infoWindow, 'domready', function () {
    adjustInfoBoxPosition()
  })

  // event when info box is opening or switchig marker
  google.maps.event.addListener(infoWindow, 'content_changed', function () {
    adjustInfoBoxPosition()
    highlightSearchResult(getInfoBoxIndex())
  })

  // event when info box is closed
  google.maps.event.addListener(infoWindow, 'closeclick', function () {
    unHighlightSearchResult()
  })

  map.addListener('bounds_changed', debounce(function (e) {
    if (apiData != null) {
      renderResults(apiData, currentLatLng)
      highlightSearchResult(getInfoBoxIndex())
    }
  }, 250))
}

// adjust position according to height
function adjustInfoBoxPosition () {
  var $ib = $('#location-map .infoBox')
  if ($ib.length > 0) {
    infoWindow.setOptions({
      pixelOffset: new google.maps.Size(30, (($ib.height() / 2) * -1) - 35),
    })
  }
}

function makeInfoWindowEvent (map, infowindow, contentString, marker) {
  // TODO: when removing old markers, we should remove their events
  google.maps.event.addListener(marker, 'click', function () {
    recentLat = marker.position.lat()
    recentLng = marker.position.lng()
    infowindow.setContent(contentString)
    infowindow.open(map, marker)
  })
}

function renderLocations (data, countryCode, currentLocation) {
  let points = []
  let minBounds = 0.15 // minimum north-south bound (to prevent very high zoom level for just one marker)
  let bounds = new google.maps.LatLngBounds()
  let markersCurrentCountry = []
  let markersCurrentLocation = []
  let markersOthers = []

  // clear old markers
  if (markerClusterOthers) markerClusterOthers.clearMarkers()
  if (markerClusterCurrentCountry) markerClusterCurrentCountry.clearMarkers()
  if (markerClusterCurrentLocation) markerClusterCurrentLocation.clearMarkers()

  let iconCurrentCountry = {
    url: window._mapMarkerIcon,
    scaledSize: new google.maps.Size(markerIconWidth, markerIconHeight)
  }
  let iconOthers = {
    url: window._mapMarkerIconInternational,
    scaledSize: new google.maps.Size(markerIconWidth, markerIconHeight)
  }
  data.forEach(function (node, index) {
    let location = node,
      marker
    if (node.document) {
      location = node.document // some rest calls have a document subnode
    }
    let loc = { lat: location.latitude, lng: location.longitude },
      country = location.country

    // create the marker
    if (country == countryCode || countryCode == worldWide) {
      marker = new google.maps.Marker({
        position: loc,
        title: location.title + ' ' + location.subtitle,
        icon: iconCurrentCountry
      })
      markersCurrentCountry.push(marker)
    } else {
      marker = new google.maps.Marker({
        position: loc,
        title: location.title + ' ' + location.subtitle,
        icon: iconOthers
      })
      markersOthers.push(marker)
    }

    points.push(loc) // store marker location points for later checks

    // create marker click event and info box content
    const addressBlock = `${location.addressStreet}\n${location.addressZip} ${location.addressCity}`
    let html = ''
    html += (addressBlock + '').replace(/\n/g, '<br>')
    html += '<span class="raw-address">' + (addressBlock + '').replace(/\n/g, ', ').replace(/\r/g, '') + '</span>' // store un-html-ified address for later usage
    let btn = '<a class="btn btn-dark btn-tertiary btn-infobox" data-loc="' + getCoords(location) + '">\n' +
      '    <div class="btn-txt position-relative">\n' +
      '        <span class="btn-icon">\n' +
      '            <div class="tertiary"></div>\n' +
      '        </span>\n' +
      '        <span class="btn-caption">' + window._btnTextShowLocation + '</span>\n' +
      '    </div>\n' +
      '</a>'
    let content = html + '<br>' + btn
    makeInfoWindowEvent(map, infoWindow, content, marker)

    // add marker to map bounds
    if (shouldExtendBounds(currentLocation, node, index, countryCode, country, markersCurrentCountry)) {
      bounds.extend(marker.position)
    }
  })

  if (currentLocation != null) {
    let icon = {
      url: window._mapMarkerIconCurrentLocation,
      scaledSize: new google.maps.Size(currentLocationWidth, currentLocationHeight)
    }
    let marker = new google.maps.Marker({
      position: currentLocation,
      // title: location.title + " " + location.subtitle,
      icon: icon
    })
    bounds.extend(marker.position)
    markersCurrentLocation.push(marker)
  }

  markerClusterOthers = new MarkerClusterer(map, markersOthers, mcOptionsOthers)
  markerClusterCurrentCountry = new MarkerClusterer(map, markersCurrentCountry, mcOptionsCurrent)
  markerClusterCurrentLocation = new MarkerClusterer(map, markersCurrentLocation, mcOptionsCurrent)

  // adding the area of the map that is covered by the search bar to the bounds, so the search bar is not covering any markers
  let ne = bounds.getNorthEast()
  let sw = bounds.getSouthWest()
  let totalNS = ne.lat() - sw.lat()
  bounds.extend({
    lat: (sw.lat() - (totalNS * 0.2)), // adding 20% of the total north-south stretch
    lng: sw.lng()
  })

  // increase bounds if zoom level would be too high
  if (totalNS <= minBounds) {
    bounds.extend({
      lat: (sw.lat() + (minBounds / 2)),
      lng: sw.lng()
    })
    bounds.extend({
      lat: (sw.lat() - (minBounds / 2)),
      lng: sw.lng()
    })
  }

  // set maps so that all markers fit
  map.fitBounds(bounds)

}

function shouldExtendBounds (currentLocation, node, index, countryCode, country, markersCurrentCountry) {
  return isWithinFiftyKmOrFirstNode(currentLocation, node, index) ||
    isWorldwideOrMatchesCountry(currentLocation, countryCode, country) ||
    isFirstMarkerInPriorityCountry(markersCurrentCountry, country, countryCode)
}

function isWithinFiftyKmOrFirstNode (currentLocation, node, index) {
  return currentLocation != null && node.distance != null && (node.distance <= 50 || index === 0)
}

function isWorldwideOrMatchesCountry (currentLocation, countryCode, country) {
  return currentLocation == null && (countryCode === worldWide || country === countryCode)
}

function isFirstMarkerInPriorityCountry (markersCurrentCountry, country, countryCode) {
  return markersCurrentCountry.length === 1 && country === countryCode
}

function renderResults (data, latAndLong, listOnly = false) {
  const $resultTemplate = $('#result-template')
  const showDistance = window._showDistance != null ? window._showDistance : false
  if ($resultTemplate.length === 0) return

  const template = $resultTemplate[0].innerHTML
  const $containerPriorityCountry = $('#results-container-priority-country')
  const $containerOtherCountries = $('#results-container-other-countries')
  const boundingBoxCurrent = !listOnly ? map.getBounds() : null

  const $dropdown = $('#search-countries')
  const searchSelectedCountry = $dropdown.val()
  const localeOfWebsite = $('body').attr('lang')

  const countryCode = (searchSelectedCountry === undefined || searchSelectedCountry === '' || listOnly) ? localeOfWebsite : searchSelectedCountry
  const countryCodePriority = (countryCode === worldWide) ? '' : countryCode

  let structuredLocations = {
    priorityCountry: {},
    otherCountries: {}
  }

  $containerPriorityCountry.empty()
  $containerOtherCountries.empty()

  data.forEach((node, idx) => {
    let location = node.document || node
    const loc = { lat: location.latitude, lng: location.longitude }
    const shouldRender = listOnly || (boundingBoxCurrent && boundingBoxCurrent.contains(loc))
    if (!shouldRender) return

    let distRound = node.distance ? Math.round(node.distance * 10) / 10 : 0
    let routeLink = getRouteLink(location, latAndLong, listOnly)
    let linkWebsite = getFullWebsiteLink(location.website)
    const finalAddress = getFormattedAddress(location)
    const $html = $(formatTemplate(template, idx, location, distRound, finalAddress, routeLink, linkWebsite, listOnly))

    hideMissingFields($html, location, !!latAndLong && showDistance)

    const isCurrentCountry = countryCodePriority.startsWith(location.country)
    const locationHtml = {
      html: $html,
      distance: latAndLong ? distRound : null,
      country: location.country,
      city: location.addressCity,
      hqRanking: location.hqRanking
    }

    insertAndSortLocation(structuredLocations, locationHtml, isCurrentCountry)
  })

  appendSortedLocations($containerPriorityCountry, structuredLocations.priorityCountry, $dropdown)
  appendSortedLocations($containerOtherCountries, structuredLocations.otherCountries, $dropdown)
}

function insertAndSortLocation (structuredLocations, locationHtml, isCurrentCountry) {
  let target = isCurrentCountry ? structuredLocations.priorityCountry : structuredLocations.otherCountries

  if (!target[locationHtml.country]) {
    target[locationHtml.country] = {}
  }

  if (!target[locationHtml.country][locationHtml.city]) {
    target[locationHtml.country][locationHtml.city] = []
  }

  target[locationHtml.country][locationHtml.city].push(locationHtml)
  target[locationHtml.country][locationHtml.city].sort((a, b) => {
    if (a.hqRanking === null) return 1
    if (b.hqRanking === null) return -1
    return a.hqRanking - b.hqRanking
  })
}

function appendSortedLocations ($container, locations, $dropdown) {
  Object.entries(locations).forEach(([countryCode, cities]) => {
    const countryLabel = $dropdown.find(`option[value=${countryCode}]`).text() || countryCode
    const countryHeadline = `<div><h2 class='result-headline'>${countryLabel}</h2></div>`
    $container.append(countryHeadline)

    Object.entries(cities).forEach(([cityName, branches]) => {
      branches.forEach(branch => {
        $container.append(branch.html)
      })
    })
  })
}

function getRouteLink (location, latAndLong, listOnly) {
  const baseAddress = (location.addressStreet + ' ' + location.addressZip + ' ' + location.addressCity)
    .replace(/\n|\r|\&|\?|\=|\#/g, ' ').replace(/\s\s+/g, ' ').replace(/ /g, '+')
  if (latAndLong != null && !listOnly) {
    return `https://www.google.com/maps/dir/?api=1&origin=${latAndLong.lat},${latAndLong.lng}&destination=${baseAddress}`
  }
  return `https://www.google.com/maps/search/?api=1&query=${baseAddress}`
}

function getFullWebsiteLink (website) {
  if (!website.includes('http://') && !website.includes('https://')) {
    return `https://${website}`
  }
  return website
}

function getFormattedAddress (location) {
  const { addressCity, addressStreet, addressZip } = location
  return `${addressStreet}<br>${addressZip} ${addressCity}`
}

function formatTemplate (template, idx, location, distRound, finalAddress, routeLink, linkWebsite, listOnly) {
  return template
    .replace(/%index%/g, idx)
    .replace(/%coords%/g, getCoords(location))
    .replace(/%title%/g, location.title)
    .replace(/%subtitle%/g, location.subtitle)
    .replace(/%distance%/g, listOnly ? 0 : distRound)
    .replace(/%address%/g, finalAddress.replace(/\n/g, '<br>'))
    .replace(/%routelink%/g, routeLink)
    .replace(/%telephone%/g, location.telefon)
    .replace(/%telephoneclean%/g, getCleanPhoneNumber(location))
    .replace(/%email%/g, location.email)
    .replace(/%websiteLink%/g, linkWebsite)
    .replace(/%website%/g, location.website)
    .replace(/%about%/g, location.about)
}

function hideMissingFields ($html, location, showDistance) {
  if (location.about === '') {
    $html.find('.about').hide()
  }
  if (!showDistance) $html.find('.distance').hide()
}

function getCleanPhoneNumber (loc) {
  return loc ? (loc.telefon ? loc.telefon.replace(/[^0-9+]/g, '') : '') : ''
}

function renderNoResults (text) {
  // all results and markers are kept, just an error text will be displayed
  $('#search-error').text(text)
}

function loadLocations (showResults, latlng, countryCode) {
  // TODO: add special case international site
  let cc = (countryCode == worldWide) ? '' : countryCode
  let query = `${window._apiLink}branch?country=${cc}&locale=${window.backend_properties.locale}`
  recentCountry = currentLocale
  if (latlng != null) {
    query += '&lat=' + latlng.lat + '&lon=' + latlng.lng
  }
  // console.log("loadLocations query: " + query);
  $.getJSON(query, function (data) {
    if (data != null && data.length && data.length > 0) {
      $('#search-error').text('')
      currentLatLng = latlng
      apiData = data
      renderLocations(data, countryCode, latlng)

      // brute force fix of map clusters sometimes not resolving to single markers while zooming in - use multiple repaints to get the fix asap (RW)
      setTimeout(function () {
        markerClusterCurrentCountry.repaint()
        markerClusterOthers.repaint()
      }, 250)
      setTimeout(function () {
        markerClusterCurrentCountry.repaint()
        markerClusterOthers.repaint()
      }, 500)
      setTimeout(function () {
        markerClusterCurrentCountry.repaint()
        markerClusterOthers.repaint()
      }, 1000)
      setTimeout(function () {
        markerClusterCurrentCountry.repaint()
        markerClusterOthers.repaint()
      }, 2000)
      setTimeout(function () {
        markerClusterCurrentCountry.repaint()
        markerClusterOthers.repaint()
      }, 4000)

      if (showResults) {
        renderResults(data, latlng)
      } else {
        console.log('No results will be shown on this page')
      }
    } else {
      console.error('No results from REST API')
      renderNoResults(window._errorRadiusNoLocationFound)
    }
  })
}

function findPlaceByCoords (lat, lng, callbackFn) {
  let geocoder = new google.maps.Geocoder
  let latlng = { lat: parseFloat(lat), lng: parseFloat(lng) }

  // check if we already stored geocoding address for coords
  if (reverseGeocodingLat != 0 && reverseGeocodingLng != 0) {
    //console.log("using stored geocoding address: " + reverseGeocodingAddress);
    callbackFn.call(this, reverseGeocodingAddress)
    return
  }

  // get address for coords via API
  geocoder.geocode({ 'location': latlng }, function (results, status) {
    if (status === google.maps.GeocoderStatus.OK) {
      if (results[0]) {
        // console.log("Reverse geocoding info:");
        // console.log(results[0]);

        // store data for further use, so we do not need to do another geocoder request
        reverseGeocodingAddress = results[0].formatted_address
        reverseGeocodingLat = latlng.lat
        reverseGeocodingLng = latlng.lng

        callbackFn.call(this, reverseGeocodingAddress)
      } else {
        console.error('No results found')
        callbackFn.call(this, '-')
      }
    } else {
      console.error('Geocoder failed due to: ' + status)
      callbackFn.call(this, 'Error: ' + status)
    }
  })
}

function findCoordsByPlace (address, callbackFn) {
  let geocoder = new google.maps.Geocoder()
  let componentRestrictions = (currentLocale == worldWide) ? {} : {
    country: currentLocale
  }

  // console.log("geocoder query: " + address + " :: country: " + currentLocale + " :: componentRestrictions: ");
  // console.log(componentRestrictions);
  geocoder.geocode({
    'address': address,
    'componentRestrictions': componentRestrictions
  }, function (results, status) {
    if (status === google.maps.GeocoderStatus.OK) {
      if (results[0]) {
        //log("Geocoding results: " + results[0].geometry.location.lat() + ", " + results[0].geometry.location.lng() + " -- hits: " + results.length);
        //console.log(results[0]);
        // if formatted_address == country name we should handle it as no results
        if (results[0].formatted_address == currentCountryName || results[0].types.indexOf('establishment') != -1 || results[0].types.indexOf('point_of_interest') != -1) {
          renderNoResults(window._errorLocationNotFound)
        } else {
          $('#search-error').text('')
          callbackFn.call(this, results[0].formatted_address, results[0].geometry.location.lat(), results[0].geometry.location.lng())
        }
      } else {
        console.error('No results found')
        renderNoResults(window._errorLocationNotFound)
        callbackFn.call(this, '', 0, 0)
      }
    } else {
      console.error('Geocoder failed due to: ' + status)
      renderNoResults(window._errorLocationNotFound)
      callbackFn.call(this, '', 0, 0)
    }
  })
}

// helper to get the location index out of an infobox (by finding the button data attribute)
function getInfoBoxIndex () {
  let $ibAsNode = $('<div>' + infoWindow.getContent() + '</div>')
  return $ibAsNode.find('.btn-infobox').data('loc')
}

// highlight a search result by index
function highlightSearchResult (idx) {
  unHighlightSearchResult()
  $('.result-anchor-' + idx).addClass('active')
}

// un-highlight any search result
function unHighlightSearchResult () {
  $('#result-container .result').removeClass('active')
}

// compose coords css selector string
function getCoords (location) {
  try {
    return String(location.latitude).replace(/\D+/g, '') + '_' + String(location.longitude).replace(/\D+/g, '')
  } catch (e) {
    console.error('Missing lat/lon!')
    console.log('location: ')
    console.log(location)
    return ''
  }
}

function onSearch () {
  let searchAddress = $('#search-input').val()
  if (infoWindow) {
    infoWindow.close()
    unHighlightSearchResult()
  }
  if (searchAddress != '') {
    if (window._doSearch) {
      findCoordsByPlace(searchAddress, function (address, lat, lng) {
        if (lat != 0 && lng != 0) {
          $('#search-input').val(address)
          loadLocations(window._showResults, { lat: lat, lng: lng }, currentLocale)
          let scrollPos = $('#location-map').offset().top
          window.scrollTo(0, scrollPos - 130)
        }
      })
    } else {
      var geocoder = new google.maps.Geocoder()
      let requestCountry = $('#search-countries').val()
      let componentRestrictions = (requestCountry == worldWide) ? {} : {
        country: requestCountry
      }
      geocoder.geocode({
        'address': searchAddress,
        'componentRestrictions': componentRestrictions
      }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            //log("Geocoding results: " + results[0].geometry.location.lat() + ", " + results[0].geometry.location.lng() + " -- hits: " + results.length);
            //console.log(results[0]);
            // if formatted_address == country name we should handle it as no results
            if (results[0].formatted_address == currentCountryName || results[0].types.indexOf('establishment') != -1 || results[0].types.indexOf('point_of_interest') != -1) {
              renderNoResults(window._errorLocationNotFound)
            } else {
              var json = { address: searchAddress, country: requestCountry, lat: 0, lng: 0 }
              location.href = window._locationFinderPageURL + '?' + utoa(JSON.stringify(json))
            }
          } else {
            renderNoResults(window._errorLocationNotFound)
          }
        } else {
          renderNoResults(window._errorLocationNotFound)
        }
      })
    }
  } else {
    // special case - just country (CR from 14.12.2018 / RW)
    let countryCode = $('#search-countries option:selected').val()
    // console.log("country only: " + countryCode);
    if (window._doSearch) {
      loadLocations(true, null, countryCode)
      let scrollPos = $('#location-map').offset().top
      window.scrollTo(0, scrollPos - 130)
    } else {
      let json = { address: '', country: countryCode, lat: 0, lng: 0 }
      location.href = window._locationFinderPageURL + '?' + utoa(JSON.stringify(json))
    }
  }
}

function onInfoBoxClick () {
  if (window._showResults) {
    let scrollPos = $('.result-anchor-' + $(this).data('loc')).first().offset().top
    window.scrollTo(0, scrollPos - 130)
  } else {
    let rawAddress = $(this).parent().find('.raw-address').text()
    let json = { address: rawAddress, country: recentCountry, lat: recentLat, lng: recentLng }
    location.href = window._locationFinderPageURL + '?' + utoa(JSON.stringify(json))
  }
}

// ucs-2 string to base64 encoded ascii
function utoa (str) {
  return window.btoa(unescape(encodeURIComponent(str)))
}

// base64 encoded ascii to ucs-2 string
function atou (str) {
  return decodeURIComponent(escape(window.atob(str)))
}

function init () {
  let latLng = null
  let paramCountry = ''

  // check for url parameters and init values with them
  try {
    let search = atou(location.search.substring(1))
    let params = JSON.parse(search)
    paramCountry = params.country
    if (params.address != '') {
      $('#search-input').val(params.address)
      $('#search-input').trigger('change')
    }
    if (params.lat != '' && params.lng != '') {
      latLng = { lat: params.lat, lng: params.lng }
    }
  } catch (e) {
  }
  // silently ignore errors in this case

  let $map = $('#location-map')
  if ($map.length > 0) {
    //log("Location Finder Map initializing...");
    initMap()

    // add event delegation for maps infobox button
    $map.on('click', 'a.btn-infobox', onInfoBoxClick)
  }

  let $bar = $('#search-bar')
  if ($bar.length > 0) {
    //console.log("Location Finder Search Bar initializing...");

    // check for grenke-group
    currentLocale = (paramCountry && paramCountry != '') ? paramCountry : window.backend_properties.country
    // get locale and set country dropdown
    if ((window.backend_properties.locale === worldWide)) {
      currentLocale = worldWide
    } else if (window.backend_properties.locale === 'de_GG') {
      currentLocale = 'de'
    }

    $('#search-countries').val(currentLocale).prop('selected', true).trigger('update').trigger('change')
    currentCountryName = $('#search-countries option:selected').text()
    $('#search-countries').on('change', function () {
      currentCountryName = $('#search-countries option:selected').text()
      currentLocale = $('#search-countries option:selected').val()
    })

    // location button
    $('#loc-btn').on('click', function () {
      if (reverseGeocodingLat != 0 && reverseGeocodingLng != 0) {
        // use store geo data to speed up the process and prevent unnecessary api calls
        findPlaceByCoords(reverseGeocodingLat, reverseGeocodingLng, function (address) {
          $('#search-input').val(address)
          // fire change event for placeholder behaviour
          $('#search-input').trigger('change')
          $('#search-btn').trigger('click')
        })
      } else {
        navigator.geolocation.getCurrentPosition(function (position) {
            //console.log("geo loc: " + position.coords.latitude + " :: " + position.coords.longitude);
            findPlaceByCoords(position.coords.latitude, position.coords.longitude, function (address) {
              $('#search-input').val(address)
              // fire change event for placeholder behaviour
              $('#search-input').trigger('change')
              $('#search-btn').trigger('click')
            })
          },
          (error) => {
            $('#location-popup-geo-error').modal('show')
          })
      }
    })

    // search button
    $('#search-btn').on('click', onSearch)

    // enter key in input field
    $('#search-input').on('keyup', function (e) {
      if (e.keyCode == 13) {
        onSearch()
      }
    })
  }

  if ($map.length > 0) {
    // loading location data
    if (!window._doSearch) {
      loadLocations(window._showResults, latLng, currentLocale)
    } else {
      onSearch()
    }
  }
}

function showLocationListOnly () {
  const countryCode = $('body').attr('lang')
  const cc = countryCode === worldWide ? '' : countryCode
  const query = `${window._apiLink}branch?country=${cc}&locale=${window.backend_properties.locale}`

  $.getJSON(query, function (data) {
    if (data && data.length > 0) {
      apiData = data
      renderResults(data, null, true)
    } else {
      console.error('No results from REST API')
    }
  })
}

export default {
  init, showLocationListOnly
}
